import React from 'react';
import MethodsTwoContext from '../Contexts/MethodsTwo';
import axios from '../Api/MainApi';
import { requaredValid, emailValid, finalizeValid } from './../Tools/Validation';


export default class Comment extends React.Component {

  state = {
    commentEditorShow: -1,
    commentData: [],
    topicId: 0,
    userId: '',
    email: '',
    name: '',
    message: '',
    like: 0,
    disLike: 0,
    parent: '',
    errors: {}
  }


  static contextType = MethodsTwoContext;

  
  componentDidMount() {
    this.state.topicId = this.props.topicId;
    this.state.userId = this.props.userId;
      if(this.state.topicId > 0)
         this.getComment(this.state.topicId);
  }

  componentDidUpdate(){
    if(this.state.topicId == 0 && this.props.topicId > 0)
    {
    this.state.topicId = this.props.topicId;
    this.state.userId = this.props.userId;
    this.getComment(this.state.topicId);
    }
  }

  handleValidation(realTimeName) {
    requaredValid(this.state, "name", realTimeName);
    requaredValid(this.state, "email", realTimeName);
    requaredValid(this.state, "message", realTimeName);
    emailValid(this.state, "email", realTimeName);
    return finalizeValid(this.state.errors);
  }

  clearfeilds() {
    this.state = {
      ...this.state,
      email: '',
      name: '',
      message: '',
      parent: '',
      commentEditorShow: -1
    };
  }

  saveComment = (commentData) => {

    axios.post(`rest/SaveComment`,
      {
        Id: commentData.Id,
        TopicId: commentData.TopicId,
        Email: commentData.Email,
        Name: commentData.Name,
        UserId: commentData.UserId,
        Message: commentData.Message,
        Like: commentData.Like,
        DisLike: commentData.DisLike,
        Parent: commentData.Parent
      },
      {
        headers: {
          Authorization: this.context.authorizationInfo.state.accessToken
        },
      })
      .then(Response => {
        console.log('javabe akhar', Response.data);
        this.getComment(this.state.topicId);

      })
      .catch(err => {
        alert("ذخیره نشد");
        console.log(err)
      })
  }

  getComment = (topicId) => {
    console.log('mikhadbere', topicId)
    axios.get(`rest/GetComment/${topicId}`, {
      headers: {
        Authorization: this.context.authorizationInfo.state.accessToken
      },

    })
      .then(Response => {
        this.setState({
          commentData: Response.data, email: '',
          name: '',
          message: '',
          parent: '',
          commentEditorShow: -1
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  showCommentEditor(userId) {
    console.log("shooooooooooooow", userId)
    this.setState({ commentEditorShow: userId })
  }

  hideCommentEditor = () => {
    console.log("noooooooshooooooooooooow", -1)
    this.setState({ commentEditorShow: -1 })
  }

  commentLike = (id) => {
    let commentData = {
      Id: id,
      Like: -1
    }
    this.saveComment(commentData);
  }

  commentDislike = (id) => {
    let commentData = {
      Id: id,
      DisLike: -1
    }
    this.saveComment(commentData);
  }

  insertComment(parentId) {
    if (this.handleValidation()) {

      console.log('keyhastito', parentId);
      let commentData = {
        Id: 0,
        TopicId: this.state.topicId,
        Email: this.state.email,
        Name: this.state.name,
        UserId: this.state.userId,
        Message: this.state.message,
        Like: this.state.like,
        DisLike: this.state.disLike,
        Parent: parentId
      }
      this.saveComment(commentData);
    }
    else {
      //bikhodi vase in ke setstate faal beshe
      this.setState({ errors: this.state.errors });
    }
  }


  onInputchange = (event) => {
    this.state[event.target.name] = event.target.value;
    this.setState({
      [event.target.name]: event.target.value
    });
    this.handleValidation(event.target.name);
  }


  render() {
      console.log('teeedad');
    return (

      <>
                    <div class="cmt">
                      <div id="comments" class="comments clearfix ">
                        <div class="comments-title clearfix md:flex">
                          <div class="comments-title-outer w-full pb-3">
                            <div class="comments-title-inner pb-3">
                              <span class="comments-number" style={{ fontFamily: 'IRANSansFaNum-bitkala' }}>{this.state.commentData.length}</span><span>دیدگاه</span>
                            </div>
                            <span>
                              در بحث&zwnj;&zwnj; پیرامون این مقاله شرکت کنید!
                        	</span>
                          </div>
                          {this.state.commentEditorShow == -1 ? (
                            <button type="button" onClick={this.showCommentEditor.bind(this, 0)} class="w-full md:w-2/12 h-10 min-w-max bg-green-400 hover:bg-green-300 text-white  mt-2 p-2 font-medium rounded hover:text-white">
                              <span>ارسال دیدگاه</span>
                            </button>) : (<></>)}
                        </div>
                        {
                          this.state.commentEditorShow == 0 ?
                            (<div class="comment-form-outer mb-4" >
                              <div class="comment-form-holder clearfix">
                                <div id="respond" class="comment-respond">
                                  <div class="space-y-2">
                                    <div class=" justify-start items-center">
                                      <textarea id="message" placeholder="دیدگاه شما" value={this.state.message} onChange={this.onInputchange} name="message" ></textarea>
                                      <div><span class="text-red-300">{this.state.errors["message"]}</span></div>
                                    </div>
                                    <div class="md:flex md:justify-start md:items-center md:space-x-3 md:space-x-reverse md:space-y-0 space-y-2">
                                      <div class='w-full'>
                                        <input type="text" name="name" id="name" value={this.state.name} onChange={this.onInputchange} placeholder="نام و نام خانوادگی" aria-required="true" />
                                        <div><span class="text-red-300 ">{this.state.errors["name"]}</span></div>
                                      </div>
                                      <div class='w-full'>
                                        <input type="email" name="email" id="email" value={this.state.email} onChange={this.onInputchange} placeholder="پست الکترونیکی" aria-required="true" />
                                        <div><span class="text-red-300 ">{this.state.errors["email"]}</span></div>
                                      </div>
                                      <div>
                                        <button type="button" onClick={this.insertComment.bind(this, 0)} class="w-full md:w-min md:min-w-max bg-green-400 hover:bg-green-300 text-white p-3 px-6 font-medium rounded hover:text-white">
                                          <span>ارسال دیدگاه</span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>) : (<></>)
                        }
                        <div class="comments-holder">
                          <ul class="comments-list">
                            {this.state.commentData.map((e, key) => {
                              return (<>
                                {
                                  e.parent == 0 ? (
                                    <>
                                      <li>
                                        <div class="comment-holder">
                                          <div class="comment-inner clearfix ">
                                            <div class="comment-image-holder" >
                                              <img alt="" src="https://secure.gravatar.com/avatar/87efbffe14f4dc5b391d161f23aed087?s=64&amp;d=mm&amp;r=g" srcset="https://secure.gravatar.com/avatar/87efbffe14f4dc5b391d161f23aed087?s=128&amp;d=mm&amp;r=g 2x" class="avatar avatar-64 photo" height="64" width="64" loading="lazy" />
                                            </div>
                                            <div class="comment-desc-holder">
                                              <div class="comment-top-holder clearfix">
                                                <div class="kt-like-holder kt-comment-like-holder" style={{ fontFamily: 'IRANSansFaNum-bitkala' }} data-id="89873">
                                                  <div class="kt-like">
                                                    <a class="kt-like-button text-green-400 hover:text-green-300">
                                                      <i class="fa fa-thumbs-up" onClick={this.commentLike.bind(this, e.id)}></i>
                                                      <span class="kt-like-count">{e.like}</span>
                                                    </a>
                                                  </div>
                                                  <div class="kt-dislike">
                                                    <a class="kt-dislike-button text-red-400  hover:text-red-300">
                                                      <i class="fa fa-thumbs-down" onClick={this.commentDislike.bind(this, e.id)}></i>
                                                      <span class="kt-dislike-count">{e.disLike}</span>
                                                    </a>
                                                  </div>
                                                </div>
                                                <div class="comment-title-holder">
                                                  <div class="comment-title-inner">
                                                    <h4 class="comment-author text-lg font-bold">{e.name}</h4>
                                                    <a onClick={this.showCommentEditor.bind(this, e.id)} class="hover:text-red-400 text-lg  comment-reply-link" >
                                                      <i class="fa fa-reply"></i>
                                                    </a>
                                                  </div>
                                                  <span class="comment-date font-600 pt-2 pb-2">{e.date}</span>
                                                </div>
                                              </div>

                                              <div class="comment-text-holder leading-6 text-justify text-sm" id="comment-89873">
                                                <p dangerouslySetInnerHTML={{ __html: e.message.replaceAll("\n", "<br/>").replaceAll("\r", " nbsp;") }}></p>
                                              </div>

                                              {this.state.commentEditorShow == e.id ? (
                                                <div id="respond" class="comment-respond">
                                                  <h3 id="reply-title" class="comment-reply-title ">
                                                    <a onClick={this.hideCommentEditor} id="cancel-comment-reply-link" class='bg-gray-400 hover:bg-gray-200'>لغو پاسخ</a>
                                                  </h3>
                                                  <div class="space-y-2">
                                                    <div class=" justify-start items-center">
                                                      <textarea id="message" placeholder="دیدگاه شما" value={this.state.message} onChange={this.onInputchange} name="message" ></textarea>
                                                      <div><span class="text-red-300">{this.state.errors["message"]}</span></div>
                                                    </div>
                                                    <div class="md:flex md:justify-start md:items-center md:space-x-3 md:space-x-reverse md:space-y-0 space-y-2">
                                                      <div class='w-full'>
                                                        <input type="text" name="name" id="name" value={this.state.name} onChange={this.onInputchange} placeholder="نام و نام خانوادگی" aria-required="true" />
                                                        <div><span class="text-red-300 ">{this.state.errors["name"]}</span></div>
                                                      </div>
                                                      <div class='w-full'>
                                                        <input type="email" name="email" id="email" value={this.state.email} onChange={this.onInputchange} placeholder="پست الکترونیکی" aria-required="true" />
                                                        <div><span class="text-red-300 ">{this.state.errors["email"]}</span></div>
                                                      </div>
                                                      <div>
                                                        <button type="button" onClick={this.insertComment.bind(this, e.id)} class="w-full md:w-min md:min-w-max bg-green-400 hover:bg-green-300 text-white p-3 px-6 font-medium rounded hover:text-white">
                                                          <span>ارسال دیدگاه</span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (<></>)}


                                            </div>

                                          </div>
                                        </div>
                                      </li>
                                      <ul class="children">
                                        {this.state.commentData.map((e2, key2) => {
                                          return (<>
                                            {e2.parent == e.id ? (

                                              <>
                                                <li>
                                                  <div class="comment-holder">
                                                    <div class="comment-inner clearfix childComment">
                                                      <div class="comment-image-holder" >
                                                        <img alt="" src="https://secure.gravatar.com/avatar/87efbffe14f4dc5b391d161f23aed087?s=64&amp;d=mm&amp;r=g" srcset="https://secure.gravatar.com/avatar/87efbffe14f4dc5b391d161f23aed087?s=128&amp;d=mm&amp;r=g 2x" class="avatar avatar-64 photo" height="64" width="64" loading="lazy" />
                                                      </div>
                                                      <div class="comment-desc-holder">
                                                        <div class="comment-top-holder clearfix">
                                                          <div class="kt-like-holder kt-comment-like-holder" style={{ fontFamily: 'IRANSansFaNum-bitkala' }} data-id="89873">
                                                            <div class="kt-like">
                                                              <a class="kt-like-button text-green-500 hover:text-green-300" >
                                                                <i class="fa fa-thumbs-up" onClick={this.commentLike.bind(this, e2.id)}></i>
                                                                <span class="kt-like-count">{e2.like}</span>
                                                              </a>
                                                            </div>
                                                            <div class="kt-dislike">
                                                              <a class="kt-dislike-button text-red-500  hover:text-red-300" >
                                                                <i class="fa fa-thumbs-down" onClick={this.commentDislike.bind(this, e2.id)}></i>
                                                                <span class="kt-dislike-count">{e2.disLike}</span>
                                                              </a>
                                                            </div>
                                                          </div>
                                                          <div class="comment-title-holder">
                                                            <div class="comment-title-inner">
                                                              <h4 class="comment-author  text-lg font-bold">{e2.name}</h4>
                                                            </div>
                                                            <span class="comment-date font-600 pt-2 pb-2">{e2.date}</span>
                                                          </div>
                                                        </div>

                                                        <div class="comment-text-holder leading-6 text-justify text-sm" id="comment-89873">
                                                          <p dangerouslySetInnerHTML={{ __html: e2.message.replaceAll("\n", "<br/>").replaceAll("\r", " nbsp;") }}></p>
                                                        </div>

                                                      </div>

                                                    </div>
                                                  </div>
                                                </li>
                                              </>
                                            ) : (<></>)}
                                          </>)
                                        })}
                                      </ul>
                                    </>
                                  ) :
                                    (<></>)
                                }
                              </>)
                            })
                            }
                          </ul>
                        </div>
                      </div>
                    </div>

      </>
    )
  }
}


